module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-400italic.woff?06b4bfda4e139eaf3ab9872a6d66f42f";